"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.durations = exports.curves = exports.createMotionConfig = exports.animations = void 0;
var _utils = require("./utils");
const curves = {
  global: [0.6, 0, 0.15, 1],
  enterExpressive: [0.33, 0, 0, 1],
  enterFunctional: [0, 0, 0.15, 1],
  exitExpressive: [1, 0, 0.67, 1],
  exitFunctional: [0.6, 0, 1, 1],
  linear: [0, 0, 1, 1]
};
exports.curves = curves;
const durations = {
  quick: 33,
  /** Buttons, Toggles, Text, Icons, Selection Controls */
  fast1: 100,
  fast2: 133,
  fast3: 150,
  /** Short distance movements, System Messaging, Navigation Drawer, Modals */
  moderate1: 200,
  moderate2: 250,
  moderate3: 300,
  /** Large distance movements, Page Transitions, Full screen dialogue */
  slow1: 350,
  slow2: 400,
  slow3: 500,
  slow4: 1000
};
exports.durations = durations;
const animations = {
  fadeIn: (0, _utils.generateAnimToken)('opacity', [0, 1], 'enterFunctional'),
  fadeIn10: (0, _utils.generateAnimToken)('opacity', [0, 0.1], 'enterFunctional'),
  fadeIn20: (0, _utils.generateAnimToken)('opacity', [0, 0.2], 'enterFunctional'),
  fadeIn30: (0, _utils.generateAnimToken)('opacity', [0, 0.3], 'enterFunctional'),
  fadeOut: (0, _utils.generateAnimToken)('opacity', [1, 0], 'global'),
  fadeOut10: (0, _utils.generateAnimToken)('opacity', [0.1, 0], 'global'),
  fadeOut20: (0, _utils.generateAnimToken)('opacity', [0.2, 0], 'global'),
  fadeOut30: (0, _utils.generateAnimToken)('opacity', [0.3, 0], 'global'),
  slideUp: (0, _utils.generateAnimToken)('y', '-100%', 'enterFunctional'),
  slideUp8: (0, _utils.generateAnimToken)('y', -8, 'enterFunctional'),
  slideUp16: (0, _utils.generateAnimToken)('y', -16, 'enterFunctional'),
  slideUp24: (0, _utils.generateAnimToken)('y', -24, 'enterFunctional'),
  slideUp40: (0, _utils.generateAnimToken)('y', -40, 'enterFunctional'),
  slideDown: (0, _utils.generateAnimToken)('y', '100%', 'exitFunctional'),
  slideDown8: (0, _utils.generateAnimToken)('y', 8, 'global'),
  slideDown16: (0, _utils.generateAnimToken)('y', 16, 'global'),
  slideDown24: (0, _utils.generateAnimToken)('y', 24, 'global'),
  slideDown40: (0, _utils.generateAnimToken)('y', 40, 'global'),
  slideRight: (0, _utils.generateAnimToken)('x', '100%', 'global'),
  slideRight8: (0, _utils.generateAnimToken)('x', 8, 'global'),
  slideRight16: (0, _utils.generateAnimToken)('x', 16, 'global'),
  slideRight24: (0, _utils.generateAnimToken)('x', 24, 'global'),
  slideRight40: (0, _utils.generateAnimToken)('x', 40, 'global'),
  slideLeft: (0, _utils.generateAnimToken)('x', '-100%', 'global'),
  slideLeft8: (0, _utils.generateAnimToken)('x', -8, 'global'),
  slideLeft16: (0, _utils.generateAnimToken)('x', -16, 'global'),
  slideLeft24: (0, _utils.generateAnimToken)('x', -24, 'global'),
  slideLeft40: (0, _utils.generateAnimToken)('x', -40, 'global'),
  scaleUpXXS: (0, _utils.generateAnimToken)('scale', [0.98, 1], 'enterFunctional'),
  scaleUpXS: (0, _utils.generateAnimToken)('scale', [0.95, 1], 'enterFunctional'),
  scaleUpS: (0, _utils.generateAnimToken)('scale', [0.9, 1], 'enterFunctional'),
  scaleDownXXS: (0, _utils.generateAnimToken)('scale', [1, 0.98], 'global'),
  scaleDownXS: (0, _utils.generateAnimToken)('scale', [1, 0.95], 'global'),
  scaleDownS: (0, _utils.generateAnimToken)('scale', [1, 0.9], 'global')
};
exports.animations = animations;
const createMotionConfig = (effect, duration, overrides) => {
  return Object.assign({}, animations[effect], {
    duration
  }, overrides);
};
exports.createMotionConfig = createMotionConfig;